import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 500 500"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M575.31 205.62V65.621c0-5.906-5.031-10.938-10.938-10.938h-140c-5.742 0-11.211 5.031-10.938 10.938s4.812 10.938 10.938 10.938h140l-10.938-10.938V205.62c0 5.742 5.031 11.211 10.938 10.938s10.938-4.812 10.938-10.938M553.44 354.38v140l10.938-10.938h-140c-5.742 0-11.211 5.031-10.938 10.938s4.813 10.938 10.938 10.938h140c5.906 0 10.938-5.031 10.938-10.938v-140c0-5.742-5.031-11.211-10.938-10.938s-10.938 4.813-10.938 10.938M146.56 205.62v-140l-10.938 10.938h140c5.742 0 11.211-5.031 10.938-10.938s-4.812-10.938-10.938-10.938h-140c-5.906 0-10.938 5.031-10.938 10.938v140c0 5.742 5.031 11.211 10.938 10.938s10.938-4.812 10.938-10.938M124.69 354.38v140c0 5.906 5.031 10.938 10.938 10.938h140c5.742 0 11.211-5.031 10.938-10.938s-4.812-10.938-10.938-10.938h-140l10.938 10.938v-140c0-5.742-5.031-11.211-10.938-10.938s-10.938 4.813-10.938 10.938",
      style: {"stroke-width":"0","stroke-opacity":"0","stroke-miterlimit":"1"},
      transform: "matrix(1.10954 0 0 1.10954 -138.34 -60.672)"
    }, null, -1)
  ])))
}
export default { render: render }